import { Button, Spinner } from '@design-systems/canvas-ui'
import Icon, {
  CheckmarkIcon,
  CloseIcon,
  InfoIcon,
  WarningIcon,
} from '@design-systems/react-icons'

// A document type is either still being worked through or done. There is no
// estimate: a countdown that keeps slipping is worse than none.
const ExtractionProgressItem = ({ item }) => (
  <li className="extraction-progress__item">
    {item.isExtracting ? (
      <Spinner aria-hidden size="sm" />
    ) : (
      <span className="extraction-progress__marker extraction-progress__marker--done">
        <Icon size="sm" svg={CheckmarkIcon} />
      </span>
    )}
    <span
      className={
        item.isExtracting ? 'extraction-progress__label--active' : undefined
      }
    >
      {item.label}
    </span>
  </li>
)

// The waiting room between kicking extraction off and having sections to
// review. Every document type in the batch is listed, so the reviewer can
// see what extraction is working through.
const ExtractionProgressView = ({
  error = '',
  isExtracting = false,
  items = [],
  onDiscard,
  onRetry,
}) => {
  if (error) {
    return (
      <section aria-label="Extraction failed" className="extraction-progress">
        <div className="upload-documents__notice upload-documents__notice--error">
          <Icon size="lg" svg={WarningIcon} />
          <span>
            <span>{error}</span>
          </span>
        </div>
        {onRetry && (
          <div className="extraction-progress__toolbar">
            <Button onClick={onRetry} variant="primary">
              Run AI extraction again
            </Button>
          </div>
        )}
      </section>
    )
  }

  return (
    <section aria-label="Extraction progress" className="extraction-progress">
      <div className="upload-documents__notice">
        <Icon size="lg" svg={InfoIcon} />
        <span>
          <span>
            Nothing gets published until you review and confirm extracted
            sections.
          </span>
        </span>
      </div>

      {/* Only offered when the page has somewhere to send a discard; there is
          no endpoint for it yet, so most of the time this is absent. */}
      {onDiscard && (
        <div className="extraction-progress__toolbar">
          <Button onClick={onDiscard} variant="secondary">
            <span className="upload-documents__button-content">
              <Icon size="sm" svg={CloseIcon} /> Discard &amp; start over
            </span>
          </Button>
        </div>
      )}

      <div className="extraction-progress__card">
        <h2>
          {isExtracting ? 'Extraction in progress' : 'Extraction complete'}
        </h2>
        <p>
          {isExtracting
            ? 'You can leave this tab and come back — extraction keeps running.'
            : 'Every document has been extracted — open the review to approve its sections.'}
        </p>
        {/* Once the job is done every type reads as done, whatever its last
            per-file status said. */}
        <ul>
          {items.map((item) => (
            <ExtractionProgressItem
              item={{
                ...item,
                isExtracting: isExtracting && item.isExtracting,
              }}
              key={item.id}
            />
          ))}
        </ul>
      </div>
    </section>
  )
}

export default ExtractionProgressView
